module.exports = __webpack_public_path__ + "media/src/images/about/outline/extention@2x-7e55ce6fdbb57d363da724267cace846.png";